import { useEffect, useState } from "react";

import { useSnackbar } from "notistack";
import { connect } from "react-redux";

import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

import { capitalizeText } from "@ip-utils";

function Notifications({ notification }) {
  const [shown, setShown] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (notification && (!shown || shown.id !== notification.id)) {
      setShown(notification);

      const { message, variant } = notification;
      enqueueSnackbar(message || capitalizeText(variant), {
        action: (key) => (
          <IconButton
            color="inherit"
            size="small"
            onClick={() => closeSnackbar(key)}
          >
            <Close />
          </IconButton>
        ),
        variant,
      });
    }
  }, [notification, shown, enqueueSnackbar, closeSnackbar]);

  return null;
}

const mapStateToProps = (state) => ({
  notification: state.app.notification,
});

export default connect(mapStateToProps)(Notifications);
